module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phead15-a2668e220903a3c2358d15a9eb62f2b2.jpg";